import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/lib/api-client";
import type { Review } from "@/lib/types";

// Highlighted reviews only — used for the homepage carousel.
export function useReviews() {
  return useQuery({
    queryKey: ['/reviews'],
    queryFn: async (): Promise<Review[]> => {
      const res = await apiClient.get('/reviews?highlighted=true');
      if (!res.ok) throw new Error("Failed to fetch reviews");
      return res.json();
    },
  });
}

// All published/approved reviews — used for the overall rating + count badge
// so the hero reflects every approved review, not just highlighted ones.
export function usePublishedReviews() {
  return useQuery({
    queryKey: ['/reviews', 'published'],
    queryFn: async (): Promise<Review[]> => {
      const res = await apiClient.get('/reviews');
      if (!res.ok) throw new Error("Failed to fetch reviews");
      return res.json();
    },
  });
}
